import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UsersService } from '../services/users/users.service';
import { SUPERVISOR_TYPE } from '../services/users/user-types';
import { User } from '../interfaces/auth/auth.interfaces';
import { permissions } from '../interfaces/users/users.interfaces';

export interface AdminData {
  user: User | null;
  permissions: permissions | null;
}

export const adminDataResolver: ResolveFn<AdminData> = (): Observable<AdminData> => {
  const userService = inject(UsersService);
  userService.resetAccess();

  const userString = localStorage.getItem('USER');

  if (!userString) {
    return of({ user: null, permissions: null });
  }

  const user = JSON.parse(userString) as User;

  // El supervisor solo ve el mapa y sus rutas; si falla la carga no se muestra ninguna
  if (user.type === SUPERVISOR_TYPE) {
    return userService.getProfile().pipe(
      map((profile) => ({
        user,
        permissions: userService.applySupervisorAccess(profile.assigned_routes ?? []),
      })),
      catchError(() => of({ user, permissions: userService.applySupervisorAccess([]) })),
    );
  }

  // Si es administrador (type === 0), cargar permisos
  if (user.type == 0) {
    return userService.getUserPermissionsById(user.id).pipe(
      map((permissions) => {
        userService.permissions = permissions;
        return { user, permissions };
      }),
      catchError((error) => {
        console.error('Error cargando permisos:', error);
        return of({ user, permissions: null });
      }),
    );
  }

  return of({ user, permissions: null });
};
